export const SendWireContainer = () => {
  return (
    <p>Hello world!</p>
  )
}